<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="value"
                append-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="{...attrs, ...$attrs}"
                v-on="on"
            ></v-text-field>
        </template>
        <v-time-picker
            v-if="menu"
            :value="value"
            @input="$emit('input', $event)"
            full-width
            @click:minute="menu = false"
        ></v-time-picker>
    </v-menu>
</template>

<script>
export default {
    props: {
        value: String,
    },
    data() {
        return {
            menu: false,
        };
    },
};
</script>

<style></style>
